/**
 * The demo crate: a fully playable library that needs no account, no network
 * and no API keys. It is what the app shows until someone signs in.
 */

import { DEMO_TRACKS } from '../audio/demo/tracks.ts';
import type { Playlist, Track } from '../types/media.ts';

export const demoTracks: readonly Track[] = DEMO_TRACKS.map((t) => ({
  id: t.id,
  source: 'demo',
  title: t.title,
  artist: t.artist,
  album: t.album,
  duration: t.duration,
  artworkUrl: null,
  demo: t,
}));

export const demoPlaylists: readonly Playlist[] = [
  {
    id: 'demo-all',
    title: 'Demo Crate',
    subtitle: `${demoTracks.length} records`,
    source: 'demo',
    trackIds: demoTracks.map((t) => t.id),
  },
  {
    id: 'demo-slow',
    title: 'After Hours',
    subtitle: 'Slow side',
    source: 'demo',
    trackIds: ['demo-1', 'demo-4', 'demo-6'],
  },
  {
    id: 'demo-fast',
    title: 'Floor Fillers',
    subtitle: 'Fast side',
    source: 'demo',
    trackIds: ['demo-3', 'demo-5', 'demo-2'],
  },
];

/** Tracks of a demo playlist, in playlist order. An unknown id is empty. */
export function demoPlaylistTracks(id: string): Track[] {
  const p = demoPlaylists.find((x) => x.id === id);
  if (!p?.trackIds) return [];
  return p.trackIds
    .map((tid) => demoTracks.find((t) => t.id === tid))
    .filter((t): t is Track => t !== undefined);
}

/** Case-insensitive match across title, artist and album. */
export function demoSearch(q: string): Track[] {
  const s = q.trim().toLowerCase();
  if (!s) return [...demoTracks];
  return demoTracks.filter((t) =>
    `${t.title} ${t.artist} ${t.album ?? ''}`.toLowerCase().includes(s),
  );
}
